import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Host: PrintTemplate.tsx
import './PrintTemplate.css';
import Logo from './Logo';
export const PrintTemplate = ({ children, documentTitle, orientation = 'portrait', }) => {
    return (_jsxs("div", { className: "host-print-document", "data-orientation": orientation, children: [_jsxs("header", { className: "host-print-header", children: [_jsx(Logo, {}), _jsxs("div", { className: "document-meta", children: [_jsx("h2", { children: documentTitle }), _jsx("p", { children: new Date().toLocaleDateString() })] })] }), _jsx("main", { className: "host-print-body", children: children })] }));
};
